import axios from "axios";

export function addMatchRecord(registrationOneId, registrationTwoId, matchStatus) {
  return axios
    .put(
      process.env.REACT_APP_API +
        "/admin/matches/addMatchRecord/registrationOneId/" +
        registrationOneId +
        "/registrationTwoId/" +
        registrationTwoId +
        "/matchStatus/" +
        matchStatus
    )
    .then((response) => response.data);
}

export function findExistingMatch(registrationOneId, registrationTwoId) {
  return axios
    .get(
      process.env.REACT_APP_API +
        "/admin/matches/findExistingMatch/registrationOneId/" +
        registrationOneId +
        "/registrationTwoId/" +
        registrationTwoId
    )
    .then((response) => response.data);
}

export function searchMatches(matchSearchRequest) {
  return axios
    .get(process.env.REACT_APP_API + "/admin/matches/search", {
      params: new URLSearchParams(matchSearchRequest),
    })
    .then((response) => response.data);
}

export function updateMatchNotes(matchId, matchDetails) {
  return axios
    .put(process.env.REACT_APP_API + "/admin/matches/updateMatchNotes/matchId/" + matchId, matchDetails)
    .then((response) => response.data);
}

export function updateMatchStatus(matchId, matchStatus) {
  return axios
    .put(
      process.env.REACT_APP_API + "/admin/matches/updateMatchStatus/matchId/" + matchId + "/matchStatus/" + matchStatus
    )
    .then((response) => response.data);
}

export function getMatchSummaryForRegistration(registrationId) {
  return axios.get(process.env.REACT_APP_API + "/match/sharedInfo/" + registrationId).then((response) => response.data);
}
